import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FilterDrawerModule } from '@modules/feature-modules/filter-drawer/filter-drawer.module';
// import { MyProfileDialogModule } from '@modules/feature-modules/my-profile-dialog/my-profile-dialog.module';
import { SharedModule } from '@shared/shared.module';
import { AdministrationLayoutComponent } from './administration-layout/administration-layout.component';
import { HeaderComponent } from './administration-layout/header/header.component';
import { DownloadProgressComponent } from './administration-layout/download-progress/download-progress.component';
import { InstallationPromptComponent } from './administration-layout/installation-prompt/installation-prompt.component';
import { TextEditorWrapperModule } from '@modules/feature-modules/text-editor-wrapper/text-editor-wrapper.module';
import { FooterComponent } from './administration-layout/footer/footer.component';

@NgModule({
  declarations: [
    AdministrationLayoutComponent,
    HeaderComponent,
    DownloadProgressComponent,
    InstallationPromptComponent,
    FooterComponent
  ],
  imports: [RouterModule, SharedModule, FilterDrawerModule, TextEditorWrapperModule],
  exports: [],
  providers: []
})
export class LayoutModule {}
